export default "__VITE_ASSET__BBYVjnTg__"